"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const v0 = (0, utils_1.buildTypes)({
    max: 14,
    types: {
        ScoringAction: {
            _enum: [
                'UpvotePost',
                'DownvotePost',
                'SharePost',
                'CreateComment',
                'UpvoteComment',
                'DownvoteComment',
                'ShareComment',
                'FollowSpace',
                'FollowAccount'
            ]
        }
    }
});
exports.default = [v0];
